import { useState, useEffect } from "react";

/**
 * A hook to track the user's online/offline connectivity status.
 * It uses the browser's native `navigator.onLine` property and window events
 * to provide a real-time status.
 *
 * @returns {boolean} `true` if the browser is online, `false` otherwise.
 */
export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState<boolean>(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
};
